<div class="loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
</div>
<div class="modal-header">
    <mat-icon class="clickable text-transparent">&nbsp;&nbsp;&nbsp;&nbsp;</mat-icon>
    <h3 class="modal-title">Login Access &mdash; {{agencyName}}</h3>
    <mat-icon class="close clickable me-4" (click)="onClose()">close</mat-icon>
</div>

<div class="modal-body">
    <div class="vstack gap-5">
        <div class="form-check form-switch master-switch">
            <input class="form-check-input" type="checkbox" id="disableAllLogins" [checked]="allDisabled"
                (change)="toggleAll($event)" [disabled]="loading || groups.length === 0" />
            <label class="form-check-label font-semibold" for="disableAllLogins">
                Deactivate all logins for this agency
            </label>
        </div>

        <div class="vstack gap-4">
            <div class="form-check form-switch" *ngFor="let group of groups">
                <input class="form-check-input" type="checkbox" [id]="'login_group_' + group.key"
                    [(ngModel)]="group.disabled" [ngModelOptions]="{standalone: true}" [disabled]="loading" />
                <label class="form-check-label" [for]="'login_group_' + group.key">
                    <span class="d-block font-semibold">{{group.label}}</span>
                    <span class="d-block text-xs text-muted">{{group.description}}</span>
                </label>
            </div>
        </div>

        <span class="text-xs text-muted">
            Sign-in only &mdash; agency data, timesheets and invoices are unaffected.
        </span>
    </div>
    <div class="error" *ngIf="error">
        <span>{{error}}</span>
    </div>
</div>
<div class="modal-footer justify-content-center">
    <div class="text-center">
        <button type="button" class="btn btn-sm btn-neutral me-5" (click)="onClose()">
            Cancel
        </button>
        <button type="submit" class="btn btn-sm btn-primary" [disabled]="loading || groups.length === 0"
            (click)="onSubmit()">Save</button>
    </div>
</div>
